import AppTd from "@/components/AppTd";
import AppPopover from "@/components/AppPopover";
export default {
  name: "SeoCheckBoxCell",
  props: {
    item: Object,
    pushModal: Boolean,
    isSelectedItem: {
      type: Boolean,
      default: false,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false,
      required: true
    }
  },
  components: {
    AppTd,
    AppPopover
  },
  emits: ["selectItem"]
};